// src/App.jsx
import React from 'react';
import { HashRouter, BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import SignIn from './Components/SignIn';
import Home from './Components/Home';
import Test from './Components/Test';
// import SignOut from './Components/SignOut';
import EmailSender from './Components/EmailSender';
import GoToTopButton from './Components/GoToTopButton';
import Profile from './Components/Profile';
import UserListItem from './Components/UserListItem';
import NoteSearch from './Components/NoteSearch';

import SignUp from './Components/SignUp';
import SignUpEmailSent from './Components/SignUpEmailSent';
import ConfirmEmail4SignUp from './Components/ConfirmEmail4SignUp';
import ConfirmEmail4SignUpSuccess from './Components/ConfirmEmail4SignUpSuccess';
import ConfirmEmail4SignUpFailure from './Components/ConfirmEmail4SignUpFailure';

import PasswordReset from './Components/PasswordReset';
import PasswordResetEmailSent from './Components/PasswordResetEmailSent';
import ConfirmEmail4PasswordReset from './Components/ConfirmEmail4PasswordReset';
import ConfirmEmail4PasswordResetSuccess from './Components/ConfirmEmail4PasswordResetSuccess.js';
import ConfirmEmail4PasswordResetFailure from './Components/ConfirmEmail4PasswordResetFailure';

import { Shared } from './Utilities/allContext';

function App() {
  return (
    <Shared>
      <HashRouter>
        <Routes>
          <Route path="/signin" element={<SignIn />} />
          <Route path="/emailsender" element={<EmailSender />} />
          {/* <Route path="/forgotpassword" element={<ForgotPassword />} /> */}
          <Route path="/home" element={<Home />} />
          <Route path="/notesearch" element={<NoteSearch />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/test" element={<Test />} />
          <Route path="*" element={<Navigate to="/signin" />} />

          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/sign-up-email-sent" element={<SignUpEmailSent />} />
          <Route path="/confirm-email-sign-up" element={<ConfirmEmail4SignUp />} />
          <Route path="/confirm-email-sign-up-success" element={<ConfirmEmail4SignUpSuccess />} />
          <Route path="/confirm-email-sign-up-failure" element={<ConfirmEmail4SignUpFailure />} />

          <Route path="/password-reset" element={<PasswordReset />} />
          <Route path="/password-reset-email-sent" element={<PasswordResetEmailSent />} />
          <Route path="/confirm-email-password-reset" element={<ConfirmEmail4PasswordReset />} />
          <Route path="/confirm-email-password-reset-success" element={<ConfirmEmail4PasswordResetSuccess />} />
          <Route path="/confirm-email-password-reset-failure" element={<ConfirmEmail4PasswordResetFailure />} />
        </Routes>
        <GoToTopButton />
      </HashRouter>    
    </Shared>
  );
}

export default App;
